let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hYmDS")).then(() => parcelRequire('bMWVN'));